import styled from "styled-components";

type ToneProps = {
    background?: string;
    color?: string;
};

type ActiveColorProps = {
    active?: boolean;
    color: string;
};

type CalendarSelectWrapProps = {
    $fullWidth?: boolean;
};

export const SmallText = styled.div`
    color: var(--calendar-text-muted);
    font-size: 12px;
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
`;

export const Badge = styled.span<ToneProps>`
    border-radius: var(--calendar-radius-badge);
    background: ${p => p.background || "var(--calendar-surface-tertiary)"};
    color: ${p => p.color || "var(--calendar-text-soft)"};
    padding: 0.2rem 0.45rem;
    font-size: 10px;
    font-weight: 700;
`;

export const SourceChipRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
    align-items: center;
`;

export const SourceChip = styled(Badge)`
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    padding: 0.15rem 0.5rem;
    line-height: 1;
`;

export const CalendarSelectWrap = styled.div<CalendarSelectWrapProps>`
    position: relative;
    display: inline-block;
    width: ${p => p.$fullWidth ? "100%" : "auto"};
`;

export const CalendarSelectChevron = styled.span`
    position: absolute;
    top: 50%;
    right: 0.75rem;
    width: 22px;
    height: 22px;
    display: inline-grid;
    place-items: center;
    color: var(--calendar-text-soft);
    font-family: Arial, sans-serif;
    font-size: 22px;
    font-weight: 800;
    line-height: 0;
    pointer-events: none;
    transform: translateY(-50%) rotate(90deg);
`;

export const CategoryTab = styled.button<ActiveColorProps>`
    position: relative;
    border: 1px solid ${p => p.active ? `${p.color}66` : "transparent"};
    background: ${p => p.active ? `${p.color}22` : `${p.color}14`};
    color: ${p => p.color};
    border-radius: var(--calendar-radius-badge);
    padding: ${p => p.active ? "0.34rem 1.95rem 0.34rem 0.65rem" : "0.34rem 0.65rem"};
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
        opacity: 0.48;
        cursor: not-allowed;
    }
`;

export const CategoryTabCheck = styled.img`
    position: absolute;
    top: -6px;
    right: -4px;
    width: 16px;
    height: 16px;
    pointer-events: none;
`;

export const IconButton = styled.button`
    border: none;
    background: transparent;
    color: var(--calendar-text-soft);
    cursor: pointer;
    font-size: 14px;
`;

export const ColorRow = styled.div`
    display: flex;
    gap: 0.45rem;
    flex-wrap: wrap;
`;

export const ColorButton = styled.button<ActiveColorProps>`
    width: 14px;
    height: 14px;
    border-radius: var(--calendar-radius-round);
    border: ${p => p.active ? "2px solid #fff" : "none"};
    box-shadow: ${p => p.active ? `0 0 0 2px ${p.color}` : "none"};
    background: ${p => p.color};
    cursor: pointer;
`;

export const DetailContent = styled.div`
    display: grid;
    gap: 0.6rem;
    font-size: 14px;
    line-height: 1.5;
`;
